/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* main.js — skrypt wspolny wszystkich stron (layout_footer_js.html.twig, defer). */

/* NAGLOWKI TABEL .tabela ROWNAJA SIE DO SWOICH KOLUMN (13.09.2026, zgloszenie
   daro ze zrzutem /lotto/statystyki/roczniki/: „LOSOWAN" do lewej nad „110"
   do prawej, to samo w kazdej analizie). Komorki liczbowe maja klase
   `liczbowa` (do prawej), a <th> nad nimi nie — `.tabela thead th` ustawia
   text-align:left i naglowek stoi „od czapy" wzgledem danych. Ten sam
   ksztalt w sumy, parzyste, dekady, roczniki i kazdym kolejnym widoku
   z agentow, wiec poprawka jest tu, w jednym miejscu, a nie w dwudziestu
   szablonach: naglowek dostaje wyrownanie swojej kolumny, liczone z komorek
   pierwszych 12 wierszy. Kolumna liczbowa -> th.liczbowa (regula w
   klasy-uzupelnienie.css), kolumna wysrodkowana -> text-align:center.
   Naglowek z colspan pomijamy, bo nie ma jednej kolumny pod soba. */
(function () {
  // Large tables must share the main thread with input and paint.
  var praceKomorek = [], pozycjaPracy = 0, pracaZaplanowana = false;
  function zapiszKomorki(prace) {
    prace.forEach(function (praca) { praceKomorek.push(praca); });
    if (pracaZaplanowana || !praceKomorek.length) return;
    pracaZaplanowana = true;
    function krok() {
      var start = performance.now(), ile = 0;
      while (pozycjaPracy < praceKomorek.length && ile < 100 && performance.now() - start < 6) {
        praceKomorek[pozycjaPracy++](); ile++;
      }
      if (pozycjaPracy < praceKomorek.length) window.setTimeout(krok, 0);
      else { praceKomorek = []; pozycjaPracy = 0; pracaZaplanowana = false; }
    }
    window.setTimeout(krok, 0);
  }
  var tabelePrzedEkranem = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    var widoczne = [];
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.dataset.tabelaAktywna = '1';
      tabelePrzedEkranem.unobserve(entry.target);
      widoczne.push(entry.target);
    });
    odswiezTabele(widoczne);
  }, { rootMargin: '200px' }) : null;
  var selektorWlasnegoSortowania = [
    '[data-sort]', '[data-okna-sort]', '[data-zaleglosci-sort]',
    '[data-rekordy-przerw-sort]', '[data-roczniki-sort]', '[data-por-sort]'
  ].join(',');

  function wyrownajNaglowki(wybrane) {
    var zapisy = [];
    (wybrane || document.querySelectorAll('table.tabela')).forEach(function (t) {
      if (t.matches('.tabela-losowan, .keno-tabela, .mapa-powt') || t.closest('[data-wyniki-tabela], [data-ryt-v2]')) return;
      if (tabelePrzedEkranem && t.dataset.tabelaAktywna !== '1') return;
      var head = t.tHead && t.tHead.rows[0];
      var body = t.tBodies[0];
      if (!head || !body || !body.rows.length) return;
      var wszystkieWiersze = Array.from(body.rows), kolumnyLiczbowe = [];
      var wiersze = wszystkieWiersze.slice(0, 12);
      /* Typ kolumny ROZPOZNAJEMY z 12 pierwszych wierszy (tanio), ale klase
         `liczbowa` nadajemy CALEJ kolumnie. Do 22.09.2026 dostawalo ja tylko
         12 komorek: w tabeli 20 najczestszych par kule w pierwszej kolumnie
         stały do prawej w 12 wierszach i do lewej w reszcie (zgloszenie daro). */
      var oznacz = function (i) {
        kolumnyLiczbowe.push(i);
      };
      Array.prototype.forEach.call(head.cells, function (th, i) {
        if (th.colSpan > 1 || th.style.textAlign) return;
        var komorki = wiersze.map(function (r) { return r.cells[i]; }).filter(function (c) {
          return c && c.colSpan === 1;
        });
        if (!komorki.length) return;
        /* Tabela może podmienić tbody po starcie (np. sumy po zmianie okna).
           Nagłówek zachowuje wtedy klasę `liczbowa`, ale nowe td już jej nie
           mają. Przenosimy typ kolumny z nagłówka z powrotem na nowe komórki,
           aby cała kolumna — także pierwsza — nadal była wyrównana tak samo. */
        if (th.classList.contains('liczbowa')) {
          oznacz(i);
          return;
        }
        var liczbowe = komorki.filter(function (c) { return c.classList.contains('liczbowa'); }).length;
        if (liczbowe === komorki.length || typKolumny(wiersze, i) === 'liczba') {
          zapisy.push(function () { th.classList.add('liczbowa'); });
          oznacz(i);
          return;
        }
        var srodek = komorki.filter(function (c) { return getComputedStyle(c).textAlign === 'center'; }).length;
        if (srodek === komorki.length) zapisy.push(function () { th.classList.add('tabela-naglowek-center'); });
      });
      if (kolumnyLiczbowe.length) wszystkieWiersze.forEach(function (r) {
        zapisy.push(function () {
          if (!r.isConnected) return;
          kolumnyLiczbowe.forEach(function (i) {
            var c = r.cells[i];
            if (c && c.colSpan === 1 && !c.classList.contains('liczbowa')) c.classList.add('liczbowa');
          });
        });
      });
    });
    // Read geometry for all columns before changing classes. Alternating reads
    // and writes forced a full table layout once per column on mobile.
    zapiszKomorki(zapisy);
  }

  function tekstKomorki(komorka) {
    if (!komorka) return '';
    if (komorka.hasAttribute('data-sort')) return komorka.getAttribute('data-sort').trim();
    var czas = komorka.querySelector('time[datetime]');
    if (czas) return czas.getAttribute('datetime').trim();
    return (komorka.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function brakWartosci(wartosc) {
    return wartosc === '' || /^(?:—|–|-|brak|n\/a)$/i.test(wartosc);
  }

  function liczba(wartosc) {
    var s = String(wartosc).trim().replace(/−/g, '-').replace(/[\u00a0\u202f\s]/g, '');
    s = s.replace(/^(?:<=?|>=?)/, '').replace(/(?:%|p\.p\.|zł|pln)$/i, '');
    /* Zakresy takie jak 21–32 są kolumną liczbową. Do sortowania wystarcza
       dolna granica; przede wszystkim pozwala to nadać tej kolumnie wspólne
       wyrównanie liczbowe zamiast domyślnego wyrównania do lewej. */
    var zakres = s.match(/^([+-]?\d+(?:[.,]\d+)?)[–—]([+-]?\d+(?:[.,]\d+)?)$/);
    if (zakres) s = zakres[1];
    if (s.indexOf(',') >= 0 && s.indexOf('.') >= 0) {
      if (s.lastIndexOf(',') > s.lastIndexOf('.')) s = s.replace(/\./g, '').replace(',', '.');
      else s = s.replace(/,/g, '');
    } else if (s.indexOf(',') >= 0) {
      s = s.replace(',', '.');
    }
    return /^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/.test(s) ? Number(s) : null;
  }

  function dataCzas(wartosc) {
    var s = String(wartosc).trim(), m = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})$/);
    if (m) return Date.UTC(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    if (!/^\d{4}-\d{2}-\d{2}(?:[T ]|$)/.test(s)) return null;
    var ts = Date.parse(s);
    return Number.isFinite(ts) ? ts : null;
  }

  function typKolumny(wiersze, indeks) {
    var komorki = wiersze.map(function (wiersz) { return wiersz.cells[indeks]; }).filter(Boolean);
    var wartosci = komorki.map(tekstKomorki).filter(function (v) { return !brakWartosci(v); });
    if (!wartosci.length) return 'tekst';
    var jawnieLiczbowe = komorki.filter(function (c) {
      return c.classList.contains('liczbowa') || c.classList.contains('tabela__kwota');
    }).length;
    if (jawnieLiczbowe === komorki.length || wartosci.every(function (v) { return liczba(v) !== null; })) return 'liczba';
    if (wartosci.every(function (v) { return dataCzas(v) !== null; })) return 'data';
    return 'tekst';
  }

  function wartoscSortowania(komorka, typ) {
    var surowa = tekstKomorki(komorka);
    if (brakWartosci(surowa)) return { brak: true, wartosc: null };
    if (typ === 'liczba') {
      var n = liczba(surowa);
      return { brak: n === null, wartosc: n };
    }
    if (typ === 'data') {
      var d = dataCzas(surowa);
      return { brak: d === null, wartosc: d };
    }
    return { brak: false, wartosc: surowa };
  }

  function maWlasneSortowanie(tabela) {
    if (tabela.matches('[data-pairs-matrix], [data-rytmy-siatka], [data-por-table], .mapa-powt')) return true;
    return !!tabela.tHead.querySelector(selektorWlasnegoSortowania + ', button');
  }

  function ustawStanSortowania(tabela, aktywny, kierunek) {
    tabela.querySelectorAll('thead th[data-sortowanie-auto]').forEach(function (th) {
      var jest = th === aktywny;
      th.setAttribute('aria-sort', jest ? (kierunek === 1 ? 'ascending' : 'descending') : 'none');
      var znak = th.querySelector('.tabela__sort-znak');
      if (znak) znak.textContent = jest ? (kierunek === 1 ? '▲' : '▼') : '⇅';
    });
  }

  function sortujTabele(tabela, th, indeks) {
    if (tabela.getAttribute('aria-busy') === 'true') return;
    var body = tabela.tBodies[0], wszystkieWiersze = Array.prototype.slice.call(body.rows);
    var paryWierszy = tabela.dataset.sortFollowRow === '1';
    var wiersze = paryWierszy ? wszystkieWiersze.filter(function (row) { return row.hasAttribute('data-sort-primary'); }) : wszystkieWiersze;
    if (wiersze.length < 2) return;
    tabela.setAttribute('aria-busy', 'true');
    // Paint the busy state before reading thousands of cells. Keep missing
    // values at the end and preserve the original order of tied values.
    var typ, stabilne = [], cursor = 0, liczby = true, daty = true, jawne = true, saWartosci = false;
    var stan = th.getAttribute('aria-sort');
    var jezyk = document.documentElement.lang || 'pl';
    var porownajTekst = new Intl.Collator(jezyk, { numeric: true, sensitivity: 'base' });
    function czytaj() {
      if (!tabela.isConnected || tabela.tBodies[0] !== body || body.rows.length !== wszystkieWiersze.length) { tabela.removeAttribute('aria-busy'); return; }
      var start = performance.now(), ile = 0;
      while (cursor < wiersze.length && ile++ < 100 && performance.now() - start < 6) {
        var c = wiersze[cursor].cells[indeks], s = tekstKomorki(c), brak = brakWartosci(s);
        if (c) jawne = jawne && (c.classList.contains('liczbowa') || c.classList.contains('tabela__kwota'));
        if (!brak) { saWartosci = true; liczby = liczby && liczba(s) !== null; daty = daty && dataCzas(s) !== null; }
        stabilne.push({wiersz:wiersze[cursor],sledzacy:paryWierszy && wiersze[cursor].nextElementSibling?.hasAttribute('data-sort-following') ? wiersze[cursor].nextElementSibling : null,pozycja:cursor,surowa:s,brak:brak});cursor++;
      }
      if (cursor < wiersze.length) { window.setTimeout(czytaj, 0); return; }
      typ = saWartosci && (jawne || liczby) ? 'liczba' : (saWartosci && daty ? 'data' : 'tekst');
      stabilne.forEach(function (x) { var v = typ === 'liczba' ? liczba(x.surowa) : (typ === 'data' ? dataCzas(x.surowa) : x.surowa); x.klucz = {brak:x.brak || v === null,wartosc:v}; });
      window.setTimeout(zastosuj, 0);
    }
    function zastosuj() {
    if (!tabela.isConnected || tabela.tBodies[0] !== body || body.rows.length !== wszystkieWiersze.length) { tabela.removeAttribute('aria-busy'); return; }
    var kierunek = stan === 'ascending' ? -1 : (stan === 'descending' ? 1 : (typ === 'tekst' ? 1 : -1));
    stabilne.sort(function (a, b) {
      if (a.klucz.brak !== b.klucz.brak) return a.klucz.brak ? 1 : -1;
      if (a.klucz.brak) return a.pozycja - b.pozycja;
      var wynik = typ === 'tekst'
        ? porownajTekst.compare(a.klucz.wartosc, b.klucz.wartosc)
        : a.klucz.wartosc - b.klucz.wartosc;
      return wynik === 0 ? a.pozycja - b.pozycja : wynik * kierunek;
    });
    var fragment = document.createDocumentFragment();
    stabilne.forEach(function (x) { fragment.appendChild(x.wiersz); if (x.sledzacy) fragment.appendChild(x.sledzacy); });
    body.appendChild(fragment);
    ustawStanSortowania(tabela, th, kierunek);
    tabela.removeAttribute('aria-busy');
    }
    window.requestAnimationFrame(function () { window.setTimeout(czytaj, 0); });
  }

  function wlaczSortowanie(wybrane) {
    (wybrane || document.querySelectorAll('table.tabela')).forEach(function (tabela) {
      if (tabelePrzedEkranem && tabela.dataset.tabelaAktywna !== '1') return;
      if (tabela.dataset.sortowanieAuto === '1' || !tabela.tHead || tabela.tHead.rows.length !== 1 || tabela.tBodies.length !== 1) return;
      if (maWlasneSortowanie(tabela)) return;
      var head = tabela.tHead.rows[0];
      if (!head.cells.length || Array.prototype.some.call(head.cells, function (th) { return th.colSpan > 1 || th.rowSpan > 1; })) return;
      tabela.dataset.sortowanieAuto = '1';
      Array.prototype.forEach.call(head.cells, function (th, indeks) {
        var etykieta = (th.textContent || '').replace(/\s+/g, ' ').trim();
        if (!etykieta) return;
        var przycisk = document.createElement('button');
        przycisk.type = 'button';
        przycisk.className = 'tabela__sort';
        przycisk.title = (/^en(?:-|$)/i.test(document.documentElement.lang || '') ? jst("ui.c0039d30d33d31a5") : jst("ui.b5474ef5d4086dee")) + etykieta;
        while (th.firstChild) przycisk.appendChild(th.firstChild);
        var znak = document.createElement('span');
        znak.className = 'tabela__sort-znak';
        znak.setAttribute('aria-hidden', 'true');
        znak.textContent = '⇅';
        przycisk.appendChild(znak);
        th.appendChild(przycisk);
        th.scope = 'col';
        th.dataset.sortowanieAuto = '1';
        if (!th.hasAttribute('aria-sort')) th.setAttribute('aria-sort', 'none');
        przycisk.addEventListener('click', function () { sortujTabele(tabela, th, indeks); });
      });
    });
  }

  var kolejkaTabel = new Set(), odbiorZaplanowany = false;
  function odbierzTabele() {
    var tabela = kolejkaTabel.values().next().value;
    if (!tabela) { odbiorZaplanowany = false; return; }
    kolejkaTabel.delete(tabela);
    if (tabela.isConnected) { wyrownajNaglowki([tabela]); wlaczSortowanie([tabela]); }
    window.setTimeout(odbierzTabele, 0);
  }
  function odswiezTabele(wybrane) {
    var tabele = wybrane || document.querySelectorAll('table.tabela');
    tabele.forEach(function (table) {
      if (tabelePrzedEkranem && table.dataset.tabelaAktywna !== '1') tabelePrzedEkranem.observe(table);
      if (!tabelePrzedEkranem || table.dataset.tabelaAktywna === '1') kolejkaTabel.add(table);
    });
    if (kolejkaTabel.size && !odbiorZaplanowany) {
      odbiorZaplanowany = true;
      window.setTimeout(odbierzTabele, 0);
    }
  }
  // Skrypt jest `defer`, wiec pierwszy DOM juz stoi. Nie wystarcza jednak
  // pojedyncze wywolanie: analizator „Moj zestaw" i kolejne moduly tworza
  // cale tabele dopiero po kliknieciu. Obserwator uruchamia ten sam wspolny
  // odbior po dodaniu wezlow, bez kopiowania logiki do kazdego modulu.
  odswiezTabele();
  if (window.MutationObserver && document.body) {
    var obserwator = new MutationObserver(function (zmiany) {
      var zmienione = new Set();
      zmiany.forEach(function (zmiana) {
        var tabela = zmiana.target.nodeType === 1 && zmiana.target.closest('table.tabela');
        if (tabela) zmienione.add(tabela);
        Array.prototype.forEach.call(zmiana.addedNodes, function (wezel) {
          if (wezel.nodeType !== 1) return;
          if (wezel.matches('table.tabela')) zmienione.add(wezel);
          if (wezel.childElementCount) wezel.querySelectorAll('table.tabela').forEach(function (t) { zmienione.add(t); });
        });
      });
      if (zmienione.size) odswiezTabele(Array.from(zmienione));
    });
    obserwator.observe(document.body, { childList: true, subtree: true });
  }

  /* FALA 9-E: pomoc metryki (_pomoc_metryka.html.twig, <details data-pomoc-
     metryka>). Samo otwieranie/zamykanie dziala z natywnego <details> bez
     JS (klawiatura Enter/Spacja po Tab, dotyk tap) — to ponizej to tylko
     dwa dodatki: Escape zamyka najblizsza otwarta pomoc (native <details>
     nie reaguje na Escape), a otwarcie jednej zamyka pozostale otwarte na
     stronie, zeby przy kilku metrykach obok siebie tresci sie nie stukaly. */
  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!(el && el.matches && el.matches('[data-pomoc-metryka]')) || !el.open) return;
    document.querySelectorAll('[data-pomoc-metryka][open]').forEach(function (inny) {
      if (inny !== el) inny.open = false;
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var otwarta = document.activeElement && document.activeElement.closest
      ? document.activeElement.closest('[data-pomoc-metryka][open]')
      : null;
    if (!otwarta) otwarta = document.querySelector('[data-pomoc-metryka][open]');
    if (!otwarta) return;
    var przycisk = otwarta.querySelector('summary.pomoc-metryka__przycisk');
    otwarta.open = false;
    if (przycisk) przycisk.focus();
  });

  /* Przyklejony naglowek z jezykami obok dostepnosci:
     - w dol znika caly naglowek, w gore wraca razem z jezykami.
     Menu mobilne i obsluga klawiatura maja pierwszenstwo przed chowaniem. */
  (function () {
    var naglowek = document.querySelector('header[data-naglowek]');
    if (!naglowek) return;

    var menu = naglowek.querySelector('#menu-przelacznik');
    var ostatniY = 0;
    var pozycjaGotowa = false;
    var sumaKierunku = 0;
    var ostatniKierunek = 0;
    var zaplanowane = false;
    var PROG_NAGLOWKA = 180;
    var RUCH_W_DOL = 18;
    var RUCH_W_GORE = 6;

    function maAktywnyElement() {
      return naglowek.contains(document.activeElement);
    }

    function menuOtwarte() {
      return !!(menu && menu.checked);
    }

    function pokazNaglowek() {
      naglowek.classList.remove('naglowek--ukryty');
    }

    function odswiez() {
      zaplanowane = false;
      var y = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      if (!pozycjaGotowa) {
        ostatniY = y;
        pokazNaglowek();
        return;
      }
      var roznica = y - ostatniY;
      var kierunek = roznica > 0 ? 1 : (roznica < 0 ? -1 : 0);

      if (menuOtwarte() || maAktywnyElement() || y <= PROG_NAGLOWKA) {
        pokazNaglowek();
        sumaKierunku = 0;
      } else if (kierunek !== 0) {
        if (kierunek !== ostatniKierunek) sumaKierunku = 0;
        sumaKierunku += roznica;
        ostatniKierunek = kierunek;

        if (kierunek < 0 && sumaKierunku <= -RUCH_W_GORE) {
          pokazNaglowek();
          sumaKierunku = 0;
        } else if (kierunek > 0 && sumaKierunku >= RUCH_W_DOL) {
          naglowek.classList.add('naglowek--ukryty');
          sumaKierunku = 0;
        }
      }

      ostatniY = y;
    }

    function zaplanuj() {
      if (zaplanowane) return;
      zaplanowane = true;
      window.requestAnimationFrame(odswiez);
    }

    window.addEventListener('scroll', zaplanuj, { passive: true });
    window.addEventListener('resize', zaplanuj);
    naglowek.addEventListener('focusin', function () {
      pokazNaglowek();
    });
    naglowek.addEventListener('focusout', zaplanuj);
    if (menu) menu.addEventListener('change', zaplanuj);
    // scrollY przy starcie defer wymuszal layout calej strony przed paint.
    // Najpierw wyswietlamy naglowek; odczyt przywroconej pozycji wykonujemy
    // po pierwszej klatce. Obsluga scroll/focus/menu pozostaje natychmiastowa.
    function przygotujPozycje() {
      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          ostatniY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
          pozycjaGotowa = true;
          odswiez();
        }, 100);
      });
    }
    // Poczekaj na arkusze i pierwszy paint. DOMContentLoaded może poprzedzać
    // ustabilizowanie layoutu; nie traktujemy odtworzenia scrollu jako gestu.
    if (document.readyState === 'complete') przygotujPozycje();
    else window.addEventListener('load', przygotujPozycje, { once: true });
  })();
  // Szerokie zwykłe zestawienia na telefonie: podpisane pola wiersza zamiast
  // ukrywania danych. Siatki wyników mają własne sterowanie i nie są kartami.
  (function () {
    var active = new WeakSet();
    var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target); active.add(entry.target);
        setTimeout(function () { adapt(entry.target); }, 0);
      });
    }, { rootMargin: '200px' }) : null;
    function adapt(table) {
      if (!table.classList.contains('tabela') || table.matches('.tabela-losowan, .keno-tabela, .mapa-powt') || table.closest('[data-ryt-v2], [data-wyniki-tabela]')) return;
      if (observer && !active.has(table)) { observer.observe(table); return; }
      var headers = table.querySelectorAll('thead tr:first-child > th');
      if (headers.length < 5 || headers.length > 10 || table.querySelector('[colspan], [rowspan]')) return;
      table.setAttribute('data-mobile-wiersze', '');
      var labels = Array.from(headers, function (header) { return header.textContent.replace(/[↕⇅↑↓]/g, '').trim(); });
      var prace = [];
      table.querySelectorAll('tbody tr').forEach(function (row) {
        prace.push(function () {
          if (!row.isConnected || row.children.length !== headers.length) return;
          Array.from(row.children).forEach(function (cell, i) {
            if (cell.getAttribute('data-mobile-label') !== labels[i]) cell.setAttribute('data-mobile-label', labels[i]);
          });
        });
      });
      zapiszKomorki(prace);
    }
    function scan(node) {
      if (!node || node.nodeType !== 1) return;
      if (node.matches('table.tabela')) adapt(node);
      node.querySelectorAll('table.tabela').forEach(adapt);
    }
    scan(document.body);
    var dirty = new Set(), scheduled = false;
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        var parentTable = change.target.nodeType === 1 && change.target.closest('table.tabela');
        if (parentTable) dirty.add(parentTable);
        change.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('table.tabela')) dirty.add(node);
          if (node.childElementCount) node.querySelectorAll('table.tabela').forEach(function (table) { dirty.add(table); });
        });
      });
      // A rebuilt tbody can add hundreds of nodes in one mutation batch.
      // Adapt each table once, instead of relabelling all rows per node.
      if (!scheduled && dirty.size) {
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          dirty.forEach(function (table) { if (table.isConnected) adapt(table); });
          dirty.clear();
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  // Na telefonie skrót notatnika nie zasłania aktywnego formularza/klawiatury.
  (function () {
    function refresh() {
      var shortcut = document.querySelector('[data-mk-skrot]'), active = document.activeElement;
      if (shortcut) shortcut.setAttribute('data-mk-input-focus', active && active.matches('input, textarea, select') && active.closest('main') ? '1' : '0');
    }
    document.addEventListener('focusin', refresh);
    document.addEventListener('focusout', function () { window.requestAnimationFrame(refresh); });
  })();
  // Wspolne oznaczenia akcji. Formularz zatwierdzamy znakiem V, a usuwanie
  // i czyszczenie znakiem X. Filtry zakresu, wyszukiwarka i losowanie maja
  // wlasne znaczenie oraz ikony, dlatego nie sa tu oznaczane automatycznie.
  (function () {
    var ns = 'http://www.w3.org/2000/svg';
    var deleteSelector = [
      '.przycisk--usun', '.mk-akcja--usun', '.mk-akcja--usun-tak',
      '[data-mz-usun]', '[data-mz-usun-tak]', '[data-obs-usun]',
      '[data-porownanie-usun]', '[data-szk-usun]', '[data-dj-clear]',
      '[data-dj-clear-yes]', '[data-hub-wyczysc]', '[data-mkc-wyczysc-filtry]'
    ].join(',');

    function icon(name) {
      var svg = document.createElementNS(ns, 'svg');
      var path = document.createElementNS(ns, 'path');
      svg.setAttribute('class', 'ikona');
      svg.setAttribute('data-ikona', name);
      svg.setAttribute('width', '18');
      svg.setAttribute('height', '18');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      path.setAttribute('d', name === 'usun' ? 'M18 6 6 18M6 6l12 12' : (name === 'akcja' ? 'M5 12h14m-6-6 6 6-6 6' : 'M20 6 9 17l-5-5'));
      svg.appendChild(path);
      return svg;
    }

    function startsWithAny(text, prefixes) {
      return prefixes.some(function (prefix) {
        return text === prefix || text.indexOf(prefix + ' ') === 0;
      });
    }

    function destructive(button) {
      if (button.matches(deleteSelector)) return true;
      var label = (button.textContent || '').trim().toLocaleLowerCase();
      return startsWithAny(label, [jst("main_js.literal.adc24b44994b"), jst("main_js.literal.f387296c6417"), jst("main_js.literal.32c61f9a006f"), 'delete', 'clear', jst("ui.54339b32ee0b500e")]);
    }

    function confirms(button) {
      if (button.matches('.przycisk--losuj,[name="zakres"],[data-gen-losuj],[data-kupony-losuj],[data-kupony-euro-losuj],[data-mk-losuj],[data-zestaw-losuj],[data-mz-dolosuj]')) return false;
      if (button.closest('.szukaj-serwis,[role="search"]')) return false;
      if ((button.getAttribute('type') || '').toLowerCase() === 'submit') return true;
      var label = (button.textContent || '').trim().toLocaleLowerCase();
      return startsWithAny(label, [jst("main_js.literal.e8476815a415"), jst("main_js.literal.8d6cbf59dc09"), 'confirm', 'submit']);
    }

    function decorate(button) {
      if (!button || button.nodeType !== 1 || !button.matches('button,a.przycisk')) return;
      // Preserve existing SVG, image, ball and compact numeric controls.
      if (button.querySelector('svg,img,.ikona,.kula') || button.closest('[data-no-action-icon]')) return;
      var text = (button.textContent || '').trim();
      if (!text || /^[\d\s.,+−×✕✖xX←→‹›«»–—-]+$/.test(text)) return;
      var remove = destructive(button);
      var confirm = !remove && confirms(button);
      
      button.setAttribute('data-ui-action', remove ? 'usun' : (confirm ? 'zatwierdz' : 'akcja'));
      // Opis pozostaje w aria-label; tekstowy krzyzyk nie dubluje ikony SVG.
      if (remove && button.getAttribute('aria-label') && /^[×✕✖xX]$/.test((button.textContent || '').trim())) {
        Array.prototype.slice.call(button.childNodes).forEach(function (node) {
          if (node.nodeType === 3) node.remove();
        });
      }
      if (!button.querySelector('.ikona')) button.insertBefore(icon(remove ? 'usun' : (confirm ? 'ptaszek' : 'akcja')), button.firstChild);
    }

    function scan(node) {
      if (!node || node.nodeType !== 1) return;
      if (node.matches('button,a.przycisk')) decorate(node);
      node.querySelectorAll('button,a.przycisk').forEach(decorate);
    }

    scan(document.body);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        var owner = change.target.nodeType === 1 ? change.target.closest('button,a.przycisk') : change.target.parentElement && change.target.parentElement.closest('button,a.przycisk');
        if (owner) decorate(owner);
        change.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  // Wspólny znacznik aktualnej strony; reaguje również na paginację tworzoną w JS.
  (function () {
    function update() {
      document.querySelectorAll('[aria-current="page"],[aria-current="true"],[data-ui-current-page]').forEach(function (item) {
        var current = item.getAttribute('aria-current');
        var page = /^(?:✓\s*)?\d+$/.test((item.textContent || '').trim())
          && item.closest('nav,[class*="pagin"],[class*="stron"],[data-wyniki-strony]');
        if (page && (current === 'page' || current === 'true')) item.setAttribute('data-ui-current-page', '1');
        else item.removeAttribute('data-ui-current-page');
      });
    }
    var pending = false;
    update();
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; update(); });
    }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['aria-current']});
  })();
})();

/* Pomiar nawigacji wynik -> raport -> analiza. Istniejący gtag obsługuje zgodę. */
(function (root, doc) {
    'use strict';
    if (root.pewniakiNavigationMeasured) return;
    root.pewniakiNavigationMeasured = true;
    doc.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('a[href]');
        if (!link || typeof root.gtag !== 'function') return;
        var action = link.hasAttribute('data-home-results') ? 'results_table' :
            link.hasAttribute('data-home-report') ? 'draw_report' :
            link.closest('[data-pilot-raport-lotto]') ? 'report_analysis' : '';
        if (!action) return;
        var url; try { url = new URL(link.href, location.href); } catch (_) { return; }
        if (url.origin !== location.origin) return;
        if (action === 'report_analysis' && !url.searchParams.has('raport_metoda')) return;
        var card = link.closest('[data-ug-gra]');
        var match = url.pathname.match(/(?:^|\/)(lotto-plus|mini-lotto|multi-multi|eurojackpot|lotto|kaskada|keno)(?:\/|$)/);
        var game = card ? card.getAttribute('data-ug-gra') : (match ? match[1] : '');
        if (!/^(lotto-plus|mini-lotto|multi-multi|eurojackpot|lotto|kaskada|keno)$/.test(game)) return;
        var lang = (doc.documentElement.lang || '').split('-')[0];
        if (!/^(pl|en|de|es|nl)$/.test(lang)) return;
        root.gtag('event', 'lottery_navigation', {
            action: action, game: game, language: lang,
            source: action === 'report_analysis' ? 'draw_report' : 'homepage',
            viewport: root.matchMedia('(max-width: 1023px)').matches ? 'mobile' : 'desktop'
        });
    });
})(window, document);
